<template>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {db} from '../firebase'
  import { CAN_SHOW_SURVEY } from '@/config'

  export default {
    methods: {
      ...mapActions({
        getNGWords: 'masterData/getNGWords',
        getNumberUnReadApprove: 'masterData/getUnreadFineplayApprove',
        addNGWord: 'masterData/addNGWord',
        updateNGWord: 'masterData/updateNGWord',
        deleteNGWord: 'masterData/deleteNGWord',
        getNumberSurveyNotComplete: 'masterData/getNumberSurveyNotComplete'
      })
    },
    computed: {
      ...mapGetters({
        notifications: 'masterData/notifications'
      }),
      canShowSurvey () {
        return CAN_SHOW_SURVEY.indexOf(this.$auth.user().authority) !== -1
      }
    },
    async mounted () {
      this.getNGWords()
      this.getNumberUnReadApprove()
      setTimeout(() => {
        if (this.$auth.user().is_maker && this.canShowSurvey) {
          this.getNumberSurveyNotComplete()
        }
      }, 1000)
      let newItem = false
      const ngWordRef = db.ref(`ngWord`)
      ngWordRef.off()
      ngWordRef.on('child_added', data => {
        if (!newItem) return
        this.addNGWord(data.val())
      })
      ngWordRef.once('value', () => {
        newItem = true
      })
      ngWordRef.on('child_changed', data => {
        this.updateNGWord(data.val())
      })
      ngWordRef.on('child_removed', data => {
        this.deleteNGWord(data.val())
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/init.vue